"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWarningAlert = exports.WarningAlert = void 0;
var tslib_1 = require("tslib");
var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
var WarningAlert_1 = require("@reactionable/core/lib/ui/alert/WarningAlert");
var react_1 = tslib_1.__importDefault(require("react"));
var Alert_1 = require("./Alert");
exports.WarningAlert = function (props) {
    return react_1.default.createElement(Alert_1.Alert, tslib_1.__assign({ variant: "warning", icon: { icon: free_solid_svg_icons_1.faExclamationTriangle } }, props));
};
exports.useWarningAlert = function (props) {
    return WarningAlert_1.useWarningAlert(tslib_1.__assign({ Component: exports.WarningAlert }, props));
};
//# sourceMappingURL=WarningAlert.js.map